import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RouterOutletComponent } from '@abp/ng.core';
import { ConversationMainComponent } from './conversation-main/conversation-main.component';
import { ConversationReportDownloadComponent } from './conversation-report-download/conversation-report-download.component';

const routes: Routes = [
  {
    path: '',
     component: RouterOutletComponent,
    children: [
      {
        path: '',
         component: RouterOutletComponent,
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: ConversationMainComponent,
            data: {
              storageKey: 'conversation',
              reuseRoutesFrom: ['conversation/:id'],
            },
          },
          {
            path: 'result/:resultId',
            component: ConversationMainComponent,
          },
          {
            path: 'report/:id',
            component: ConversationReportDownloadComponent,
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ConversationRoutingModule {}
